import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Cart } from '../../../../Services/Cart';
import { CartService } from '../../../../Services/cart.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.css'
})
export class CartComponent implements OnInit {
  billingDetails: any = null;
  constructor(private _cart: CartService) { }

  ngOnInit(): void {

    this._cart.cartItems().subscribe(items => {
      this.billingDetails = {
        grossAmount: this._cart.GrossAmount(),
        discountAmount: this._cart.DiscountAmount(),
        gstAmount: this._cart.GSTAmount(),
        netAmount: this._cart.NetAmount(),
        cartItems: items || []
      }
    });
  }
  removeItem(index: number) {
    this._cart.remove(index);
  }

}  